import { defineMessages } from 'react-intl'

export default defineMessages({
  baq: { id: 'data.languages.baq', defaultMessage: 'Basque' },
  baqURL: { id: 'data.languages.baq.url', defaultMessage: 'basque' },
  bel: { id: 'data.languages.bel', defaultMessage: 'Belarusian' },
  belURL: { id: 'data.languages.bel.url', defaultMessage: 'belarusian' },
  cat: { id: 'data.languages.cat', defaultMessage: 'Catalan' },
  catURL: { id: 'data.languages.cat.url', defaultMessage: 'catalan' },
  ewe: { id: 'data.languages.ewe', defaultMessage: 'Ewe' },
  eweURL: { id: 'data.languages.ewe.url', defaultMessage: 'ewe' },
  lue: { id: 'data.languages.lue', defaultMessage: 'Luvale' },
  lueURL: { id: 'data.languages.lue.url', defaultMessage: 'luvale' },
  lbn: { id: 'data.languages.lbn', defaultMessage: 'Lozi' },
  lbnURL: { id: 'data.languages.lbn.url', defaultMessage: 'lozi' },
  toi: { id: 'data.languages.toi', defaultMessage: 'Tonga' },
  toiURL: { id: 'data.languages.toi.url', defaultMessage: 'tonga' },
  tgk: { id: 'data.languages.tgk', defaultMessage: 'Tajiki' },
  tgkURL: { id: 'data.languages.tgk.url', defaultMessage: 'tajiki' },
  mng: { id: 'data.languages.mng', defaultMessage: 'Mongolian' },
  mngURL: { id: 'data.languages.mng.url', defaultMessage: 'mongolian' },
  'ckb-IQ': { id: 'data.languages.ckb-IQ', defaultMessage: 'Sorani (Kurdish)' },
  'ckb-IQURL': {
    id: 'data.languages.ckb-IQ.url',
    defaultMessage: 'sorani-kurdish',
  },
  'cy-GB': { id: 'data.languages.cy-GB', defaultMessage: 'English Welsh' },
  'cy-GBURL': {
    id: 'data.languages.cy-GB.url',
    defaultMessage: 'english-welsh',
  },
  ceb: { id: 'data.languages.ceb', defaultMessage: 'Cebuano' },
  cebURL: { id: 'data.languages.ceb.url', defaultMessage: 'cebuano' },
  'en-002': {
    id: 'data.languages.en-002',
    defaultMessage: 'English (African)',
  },
  'en-002URL': {
    id: 'data.languages.en-002.url',
    defaultMessage: 'english-african',
  },
  'en-011': {
    id: 'data.languages.en-011',
    defaultMessage: 'English (Western Africa)',
  },
  'en-011URL': {
    id: 'data.languages.en-011.url',
    defaultMessage: 'english-west-african',
  },
  'en-014': {
    id: 'data.languages.en-014',
    defaultMessage: 'English (Eastern Africa)',
  },
  'en-014URL': {
    id: 'data.languages.en-014.url',
    defaultMessage: 'english-east-african',
  },
  'en-145': { id: 'data.languages.en-145', defaultMessage: 'English (Middle_East/Arabic)' },
  'en-145URL': {
    id: 'data.languages.en-145.url',
    defaultMessage: 'english-arabic',
  },
  'en-ARIN': {
    id: 'data.languages.en-ARIN',
    defaultMessage: 'English Caribbean',
  },
  'en-ARINURL': {
    id: 'data.languages.en-ARIN.url',
    defaultMessage: 'english-caribbean',
  },
  'en-AU': { id: 'data.languages.en-AU', defaultMessage: 'English Australian' },
  'en-AUURL': {
    id: 'data.languages.en-AU.url',
    defaultMessage: 'english-australian',
  },
  'en-CA': { id: 'data.languages.en-CA', defaultMessage: 'English Canadian' },
  'en-CAURL': {
    id: 'data.languages.en-CA.url',
    defaultMessage: 'english-canadian',
  },
  'en-CC': {
    id: 'data.languages.en-CC',
    defaultMessage: 'English Western Cape',
  },
  'en-CCURL': {
    id: 'data.languages.en-CC.url',
    defaultMessage: 'english-western-cape',
  },
  'en-GB': { id: 'data.languages.en-GB', defaultMessage: 'English UK' },
  'en-GBURL': { id: 'data.languages.en-GB.url', defaultMessage: 'english-uk' },
  'en-GH': { id: 'data.languages.en-GH', defaultMessage: 'English Ghanaian' },
  'en-GHURL': {
    id: 'data.languages.en-GH.url',
    defaultMessage: 'english-ghanaian',
  },
  'en-IE': { id: 'data.languages.en-IE', defaultMessage: 'English Irish' },
  'en-IEURL': {
    id: 'data.languages.en-IE.url',
    defaultMessage: 'english-irish',
  },
  'en-IN': { id: 'data.languages.en-IN', defaultMessage: 'English Indian' },
  'en-INURL': {
    id: 'data.languages.en-IN.url',
    defaultMessage: 'english-indian',
  },
  'en-KE': { id: 'data.languages.en-KE', defaultMessage: 'English Kenyan' },
  'en-KEURL': {
    id: 'data.languages.en-KE.url',
    defaultMessage: 'english-kenyan',
  },
  'en-NG': { id: 'data.languages.en-NG', defaultMessage: 'English Nigerian' },
  'en-NGURL': {
    id: 'data.languages.en-NG.url',
    defaultMessage: 'english-nigerian',
  },
  'en-NZ': {
    id: 'data.languages.en-NZ',
    defaultMessage: 'English New Zealand',
  },
  'en-NZURL': {
    id: 'data.languages.en-NZ.url',
    defaultMessage: 'english-new-zealand',
  },
  'en-PH': { id: 'data.languages.en-PH', defaultMessage: 'English Filippino' },
  'en-PHURL': {
    id: 'data.languages.en-PH.url',
    defaultMessage: 'english-filippino',
  },
  'en-SC': { id: 'data.languages.en-SC', defaultMessage: 'English (Scottish)' },
  'en-SCURL': {
    id: 'data.languages.en-SC.url',
    defaultMessage: 'english-scottish',
  },
  'en-SG': {
    id: 'data.languages.en-SG',
    defaultMessage: 'English Singaporean',
  },
  'en-SGURL': {
    id: 'data.languages.en-SG.url',
    defaultMessage: 'english-singaporean',
  },
  'en-UG': {
    id: 'data.languages.en-UG',
    defaultMessage: 'English (Uganda)'
  },
  'en-UGURL': {
    id: 'data.languages.en-UG.url',
    defaultMessage: 'english-uganda'
  },
  'en-US': { id: 'data.languages.en-US', defaultMessage: 'English US' },
  'en-USURL': {
    id: 'data.languages.en-US.url',
    defaultMessage: 'english-american',
  },
  'en-ZA': {
    id: 'data.languages.en-ZA',
    defaultMessage: 'English South African',
  },
  'en-ZAURL': {
    id: 'data.languages.en-ZA.url',
    defaultMessage: 'english-south-african',
  },
  'es-150': {
    id: 'data.languages.es-150',
    defaultMessage: 'Spanish (European)',
  },
  'es-150URL': {
    id: 'data.languages.es-150.url',
    defaultMessage: 'spanish-european',
  },
  'es-419': { id: 'data.languages.es-419', defaultMessage: 'Spanish Latin' },
  'es-419URL': {
    id: 'data.languages.es-419.url',
    defaultMessage: 'spanish-latin',
  },
  'es-CO': {
    id: 'data.languages.es-CO',
    defaultMessage: 'Spanish-Latin Columbian',
  },
  'es-COURL': {
    id: 'data.languages.es-CO.url',
    defaultMessage: 'spanish-latin-columbian',
  },
  'es-MX': { id: 'data.languages.es-MX', defaultMessage: 'Spanish Mexican' },
  'es-MXURL': {
    id: 'data.languages.es-MX.url',
    defaultMessage: 'spanish-mexican',
  },
  'es-PE': {
    id: 'data.languages.es-PE',
    defaultMessage: 'Spanish-Latin Peruvian',
  },
  'es-PEURL': {
    id: 'data.languages.es-PE.url',
    defaultMessage: 'spanish-latin-peruvian',
  },
  'es-la_AR': {
    id: 'data.languages.es-la_AR',
    defaultMessage: 'Spanish-Latin Argentinian',
  },
  'es-la_ARURL': {
    id: 'data.languages.es-la_AR.url',
    defaultMessage: 'spanish-latin-argentinian',
  },
  'es-la_CL': {
    id: 'data.languages.es-la_CL',
    defaultMessage: 'Spanish-Latin Chilean',
  },
  'es-la_CLURL': {
    id: 'data.languages.es-la_CL.url',
    defaultMessage: 'spanish-latin-chilean',
  },
  'es-la_EC': {
    id: 'data.languages.es-la_EC',
    defaultMessage: 'Spanish-Latin Ecuadorian',
  },
  'es-la_ECURL': {
    id: 'data.languages.es-la_EC.url',
    defaultMessage: 'spanish-latin-ecuadorian',
  },
  'es-la_VE': {
    id: 'data.languages.es-la_VE',
    defaultMessage: 'Spanish-Latin Venezuelan',
  },
  'es-la_VEURL': {
    id: 'data.languages.es-la_VE.url',
    defaultMessage: 'spanish-latin-venezuelan',
  },
  'fa-001': { id: 'data.languages.fa-001', defaultMessage: 'Persian' },
  'fa-001URL': { id: 'data.languages.fa-001.url', defaultMessage: 'persian' },
  'fa-AF': { id: 'data.languages.fa-AF', defaultMessage: 'Dari' },
  'fa-AFURL': { id: 'data.languages.fa-AF.url', defaultMessage: 'dari' },
  'fi-SE': { id: 'data.languages.fi-SE', defaultMessage: 'Finnish Swedish' },
  'fi-SEURL': {
    id: 'data.languages.fi-SE.url',
    defaultMessage: 'finnish-swedish',
  },
  'fr-BE': { id: 'data.languages.fr-BE', defaultMessage: 'French Belgian' },
  'fr-BEURL': {
    id: 'data.languages.fr-BE.url',
    defaultMessage: 'french-belgian',
  },
  'fr-CA': { id: 'data.languages.fr-CA', defaultMessage: 'French Canadian' },
  'fr-CAURL': {
    id: 'data.languages.fr-CA.url',
    defaultMessage: 'french-canadian',
  },
  'fr-FR': { id: 'data.languages.fr-FR', defaultMessage: 'French Universal' },
  'fr-FRURL': {
    id: 'data.languages.fr-FR.url',
    defaultMessage: 'french-universal',
  },
  'fr-IC': { id: 'data.languages.fr-IC', defaultMessage: 'French Ivory Coast' },
  'fr-ICURL': {
    id: 'data.languages.fr-IC.url',
    defaultMessage: 'french-ivory-coast',
  },
  'id-ID': { id: 'data.languages.id-ID', defaultMessage: 'Bahasa Indonesia' },
  'id-IDURL': {
    id: 'data.languages.id-ID.url',
    defaultMessage: 'bahasa-indonesia',
  },
  'id-MY': { id: 'data.languages.id-MY', defaultMessage: 'Bahasa-Malaysia' },
  'id-MYURL': {
    id: 'data.languages.id-MY.url',
    defaultMessage: 'bahasa-malaysia',
  },
  'nl-BE': { id: 'data.languages.nl-BE', defaultMessage: 'Flemish' },
  'nl-BEURL': { id: 'data.languages.nl-BE.url', defaultMessage: 'flemish' },
  'pt-002': {
    id: 'data.languages.pt-002',
    defaultMessage: 'Portuguese (African)',
  },
  'pt-002URL': {
    id: 'data.languages.pt-002.url',
    defaultMessage: 'portuguese-african',
  },
  'pt-150': {
    id: 'data.languages.pt-150',
    defaultMessage: 'Portuguese (European)',
  },
  'pt-150URL': {
    id: 'data.languages.pt-150.url',
    defaultMessage: 'portuguese-european',
  },
  'pt-BR': {
    id: 'data.languages.pt-BR',
    defaultMessage: 'Portuguese Brazilian',
  },
  'pt-BRURL': {
    id: 'data.languages.pt-BR.url',
    defaultMessage: 'portuguese-brazilian',
  },
  'pt-AO': {
    id: 'data.languages.pt-AO',
    defaultMessage: 'Portuguese (Angolan)',
  },
  'pt-AOURL': {
    id: 'data.languages.pt-AO.url',
    defaultMessage: 'portuguese-angolan',
  },
  'pt-MZ': {
    id: 'data.languages.pt-MZ',
    defaultMessage: 'Portuguese (Mozambique)',
  },
  'pt-MZURL': {
    id: 'data.languages.pt-MZ.url',
    defaultMessage: 'portuguese-mozambican',
  },
  'sv-FI': { id: 'data.languages.sv-FI', defaultMessage: 'Swedish Finnish' },
  'sv-FIURL': {
    id: 'data.languages.sv-FI.url',
    defaultMessage: 'swedish-finnish',
  },
  'sw-TZ': { id: 'data.languages.sw-TZ', defaultMessage: 'Swahili Tanzanian' },
  'sw-TZURL': {
    id: 'data.languages.sw-TZ.url',
    defaultMessage: 'swahili-tanzanian',
  },
  'zh-Hant-TW': {
    id: 'data.languages.zh-Hant-TW',
    defaultMessage: 'Taiwan-Mandarin',
  },
  'zh-Hant-TWURL': {
    id: 'data.languages.zh-Hant-TW.url',
    defaultMessage: 'taiwan-mandarin',
  },
  af: { id: 'data.languages.af', defaultMessage: 'Afrikaans' },
  afURL: { id: 'data.languages.af.url', defaultMessage: 'afrikaans' },
  aii: { id: 'data.languages.aii', defaultMessage: 'Assyrian Neo-Aramaic' },
  aiiURL: { id: 'data.languages.aii.url', defaultMessage: 'assyrian-neo-aramaic' },
  am: { id: 'data.languages.am', defaultMessage: 'Amharic' },
  amURL: { id: 'data.languages.am.url', defaultMessage: 'amharic' },
  ar: { id: 'data.languages.ar', defaultMessage: 'Arabic' },
  arURL: { id: 'data.languages.ar.url', defaultMessage: 'arabic' },
  as: { id: 'data.languages.as', defaultMessage: 'Indian Assamese' },
  asURL: { id: 'data.languages.as.url', defaultMessage: 'indian-assamese' },
  az: { id: 'data.languages.az', defaultMessage: 'Azerbaijani' },
  azURL: { id: 'data.languages.az.url', defaultMessage: 'azerbaijani' },
  bal: { id: 'data.languages.bal', defaultMessage: 'Balochi' },
  balURL: { id: 'data.languages.bal.url', defaultMessage: 'balochi' },
  bem: { id: 'data.languages.bem', defaultMessage: 'Bemba' },
  bemURL: { id: 'data.languages.bem.url', defaultMessage: 'bemba' },
  ber: { id: 'data.languages.ber', defaultMessage: 'Tamazight' },
  berURL: { id: 'data.languages.ber.url', defaultMessage: 'tamazight' },
  bg: { id: 'data.languages.bg', defaultMessage: 'Bulgarian' },
  bgURL: { id: 'data.languages.bg.url', defaultMessage: 'bulgarian' },
  bm: { id: 'data.languages.bm', defaultMessage: 'Bambara' },
  bmURL: { id: 'data.languages.bm.url', defaultMessage: 'bambara' },
  bn: { id: 'data.languages.bn', defaultMessage: 'Indian Bengali' },
  bnURL: { id: 'data.languages.bn.url', defaultMessage: 'indian-bengali' },
  bs: { id: 'data.languages.bs', defaultMessage: 'Bosnian' },
  bsURL: { id: 'data.languages.bs.url', defaultMessage: 'bosnian' },
  ce: { id: 'data.languages.ce', defaultMessage: 'Chechen' },
  ceURL: { id: 'data.languages.ce.url', defaultMessage: 'chechen' },
  ckb: { id: 'data.languages.ckb', defaultMessage: 'Sorani' },
  ckbURL: { id: 'data.languages.ckb.url', defaultMessage: 'sorani' },
  cs: { id: 'data.languages.cs', defaultMessage: 'Czech' },
  csURL: { id: 'data.languages.cs.url', defaultMessage: 'czech' },
  cy: { id: 'data.languages.cy', defaultMessage: 'Welsh' },
  cyURL: { id: 'data.languages.cy.url', defaultMessage: 'welsh' },
  da: { id: 'data.languages.da', defaultMessage: 'Danish' },
  daURL: { id: 'data.languages.da.url', defaultMessage: 'danish' },
  de: { id: 'data.languages.de', defaultMessage: 'German' },
  deURL: { id: 'data.languages.de.url', defaultMessage: 'german' },
  de_AT: { id: 'data.languages.de_AT', defaultMessage: 'German Austrian' },
  de_ATURL: {
    id: 'data.languages.de_AT.url',
    defaultMessage: 'german-austrian',
  },
  de_CH: { id: 'data.languages.de_CH', defaultMessage: 'German Swiss' },
  de_CHURL: { id: 'data.languages.de_CH.url', defaultMessage: 'german-swiss' },
  el: { id: 'data.languages.el', defaultMessage: 'Greek' },
  elURL: { id: 'data.languages.el.url', defaultMessage: 'greek' },
  en: { id: 'data.languages.en', defaultMessage: 'English' },
  enURL: { id: 'data.languages.en.url', defaultMessage: 'english' },
  et: { id: 'data.languages.et', defaultMessage: 'Estonian' },
  etURL: { id: 'data.languages.et.url', defaultMessage: 'estonian' },
  fa: { id: 'data.languages.fa', defaultMessage: 'Farsi' },
  faURL: { id: 'data.languages.fa.url', defaultMessage: 'farsi' },
  fi: { id: 'data.languages.fi', defaultMessage: 'Finnish' },
  fiURL: { id: 'data.languages.fi.url', defaultMessage: 'finnish' },
  fil: { id: 'data.languages.fil', defaultMessage: 'Filipino' },
  filURL: { id: 'data.languages.fil.url', defaultMessage: 'filipino' },
  fng: { id: 'data.languages.fng', defaultMessage: 'Fanagalo' },
  fngURL: { id: 'data.languages.fng.url', defaultMessage: 'fanagalo' },
  fr: { id: 'data.languages.fr', defaultMessage: 'French European' },
  frURL: { id: 'data.languages.fr.url', defaultMessage: 'french-european' },
  fr_CH: { id: 'data.languages.fr_CH', defaultMessage: 'French Swiss' },
  fr_CHURL: { id: 'data.languages.fr_CH.url', defaultMessage: 'french-swiss' },
  fr_ZA: { id: 'data.languages.fr_ZA', defaultMessage: 'French African' },
  fr_ZAURL: {
    id: 'data.languages.fr_ZA.url',
    defaultMessage: 'french-african',
  },
  fro: { id: 'data.languages.fro', defaultMessage: 'Faroese' },
  froURL: { id: 'data.languages.fro.url', defaultMessage: 'faroese' },
  gd: { id: 'data.languages.gd', defaultMessage: 'Gaelic' },
  gdURL: { id: 'data.languages.gd.url', defaultMessage: 'gaelic' },
  gl: { id: 'data.languages.gl', defaultMessage: 'Galician' },
  glURL: { id: 'data.languages.gl.url', defaultMessage: 'galician' },
  gu: { id: 'data.languages.gu', defaultMessage: 'Indian Gujarati' },
  guURL: { id: 'data.languages.gu.url', defaultMessage: 'indian-gujarati' },
  ha: { id: 'data.languages.ha', defaultMessage: 'Hausa' },
  haURL: { id: 'data.languages.ha.url', defaultMessage: 'hausa' },
  hi: { id: 'data.languages.hi', defaultMessage: 'Hindi' },
  hiURL: { id: 'data.languages.hi.url', defaultMessage: 'hindi' },
  hil: { id: 'data.languages.hil', defaultMessage: 'Hiligaynon' },
  hilURL: { id: 'data.languages.hil.url', defaultMessage: 'hiligaynon' },
  hr: { id: 'data.languages.hr', defaultMessage: 'Croatian' },
  hrURL: { id: 'data.languages.hr.url', defaultMessage: 'croatian' },
  ht: { id: 'data.languages.ht', defaultMessage: 'Haitian Creole' },
  htURL: { id: 'data.languages.ht.url', defaultMessage: 'haitian-creole' },
  hu: { id: 'data.languages.hu', defaultMessage: 'Hungarian' },
  huURL: { id: 'data.languages.hu.url', defaultMessage: 'hungarian' },
  hy: { id: 'data.languages.hy', defaultMessage: 'Armenian' },
  hyURL: { id: 'data.languages.hy.url', defaultMessage: 'armenian' },
  ig: { id: 'data.languages.ig', defaultMessage: 'Igbo' },
  igURL: { id: 'data.languages.ig.url', defaultMessage: 'igbo' },
  ilo: { id: 'data.languages.ilo', defaultMessage: 'Ilocano' },
  iloURL: { id: 'data.languages.ilo.url', defaultMessage: 'ilocano' },
  is: { id: 'data.languages.is', defaultMessage: 'Icelandic' },
  isURL: { id: 'data.languages.is.url', defaultMessage: 'icelandic' },
  it: { id: 'data.languages.it', defaultMessage: 'Italian' },
  itURL: { id: 'data.languages.it.url', defaultMessage: 'italian' },
  it_CH: { id: 'data.languages.it_CH', defaultMessage: 'Italian Swiss' },
  it_CHURL: { id: 'data.languages.it_CH.url', defaultMessage: 'italian-swiss' },
  iw: { id: 'data.languages.iw', defaultMessage: 'Hebrew' },
  iwURL: { id: 'data.languages.iw.url', defaultMessage: 'hebrew' },
  ja: { id: 'data.languages.ja', defaultMessage: 'Japanese' },
  jaURL: { id: 'data.languages.ja.url', defaultMessage: 'japanese' },
  ka: { id: 'data.languages.ka', defaultMessage: 'Georgian' },
  kaURL: { id: 'data.languages.ka.url', defaultMessage: 'georgian' },
  kar: { id: 'data.languages.kar', defaultMessage: 'Karen' },
  karURL: { id: 'data.languages.kar.url', defaultMessage: 'karen' },
  kir: { id: 'data.languages.kir', defaultMessage: 'Kyrgyz' },
  kirURL: { id: 'data.languages.kir.url', defaultMessage: 'kyrgyz' },
  kj: { id: 'data.languages.kj', defaultMessage: 'Oshiwambo' },
  kjURL: { id: 'data.languages.kj.url', defaultMessage: 'oshiwambo' },
  kk: { id: 'data.languages.kk', defaultMessage: 'Kazakh' },
  kkURL: { id: 'data.languages.kk.url', defaultMessage: 'kazakh' },
  kl: { id: 'data.languages.kl', defaultMessage: 'Greenlandic' },
  klURL: { id: 'data.languages.kl.url', defaultMessage: 'greenlandic' },
  km: { id: 'data.languages.km', defaultMessage: 'Khmer' },
  kmURL: { id: 'data.languages.km.url', defaultMessage: 'khmer' },
  kmr: { id: 'data.languages.kmr', defaultMessage: 'Kurmanji Kurdish' },
  kmrURL: { id: 'data.languages.kmr.url', defaultMessage: 'kurmanji-kurdish' },
  kn: { id: 'data.languages.kn', defaultMessage: 'Indian Kannada' },
  knURL: { id: 'data.languages.kn.url', defaultMessage: 'indian-kannada' },
  ko: { id: 'data.languages.ko', defaultMessage: 'Korean' },
  koURL: { id: 'data.languages.ko.url', defaultMessage: 'korean' },
  kqn: { id: 'data.languages.kqn', defaultMessage: 'Kaonde' },
  kqnURL: { id: 'data.languages.kqn.url', defaultMessage: 'kaonde' },
  lb: { id: 'data.languages.lb', defaultMessage: 'Luxembourgish' },
  lbURL: { id: 'data.languages.lb.url', defaultMessage: 'luxembourgish' },
  lg: { id: 'data.languages.lg', defaultMessage: 'Lugandan' },
  lgURL: { id: 'data.languages.lg.url', defaultMessage: 'lugandan' },
  ln: { id: 'data.languages.ln', defaultMessage: 'Lingala' },
  lnURL: { id: 'data.languages.ln.url', defaultMessage: 'lingala' },
  lo: { id: 'data.languages.lo', defaultMessage: 'Laotian' },
  loURL: { id: 'data.languages.lo.url', defaultMessage: 'laotian' },
  lt: { id: 'data.languages.lt', defaultMessage: 'Lithuanian' },
  ltURL: { id: 'data.languages.lt.url', defaultMessage: 'lithuanian' },
  lun: { id: 'data.languages.lun', defaultMessage: 'Lunda' },
  lunURL: { id: 'data.languages.lun.url', defaultMessage: 'lunda' },
  luo: { id: 'data.languages.luo', defaultMessage: 'Dholuo' },
  luoURL: { id: 'data.languages.luo.url', defaultMessage: 'dholuo' },
  lv: { id: 'data.languages.lv', defaultMessage: 'Latvian' },
  lvURL: { id: 'data.languages.lv.url', defaultMessage: 'latvian' },
  mfe: { id: 'data.languages.mfe', defaultMessage: 'Mauritian Creole' },
  mfeURL: { id: 'data.languages.mfe.url', defaultMessage: 'mauritian-creole' },
  mg: { id: 'data.languages.mg', defaultMessage: 'Malagasy' },
  mgURL: { id: 'data.languages.mg.url', defaultMessage: 'malagasy' },
  mis: { id: 'data.languages.mis', defaultMessage: 'Montenegrin' },
  misURL: { id: 'data.languages.mis.url', defaultMessage: 'montenegrin' },
  mk: { id: 'data.languages.mk', defaultMessage: 'Macedonian' },
  mkURL: { id: 'data.languages.mk.url', defaultMessage: 'macedonian' },
  ml: { id: 'data.languages.ml', defaultMessage: 'Malayalam' },
  mlURL: { id: 'data.languages.ml.url', defaultMessage: 'malayalam' },
  mn: { id: 'data.languages.mn', defaultMessage: 'Mongolian' },
  mnURL: { id: 'data.languages.mn.url', defaultMessage: 'mongolian' },
  mnk: { id: 'data.languages.mnk', defaultMessage: 'Mandinka' },
  mnkURL: { id: 'data.languages.mnk.url', defaultMessage: 'mandinka' },
  mr: { id: 'data.languages.mr', defaultMessage: 'Marathi' },
  mrURL: { id: 'data.languages.mr.url', defaultMessage: 'marathi' },
  mt: { id: 'data.languages.mt', defaultMessage: 'Maltese' },
  mtURL: { id: 'data.languages.mt.url', defaultMessage: 'maltese' },
  my: { id: 'data.languages.my', defaultMessage: 'Burmese' },
  myURL: { id: 'data.languages.my.url', defaultMessage: 'burmese' },
  nd: { id: 'data.languages.nd', defaultMessage: 'Ndebele' },
  ndURL: { id: 'data.languages.nd.url', defaultMessage: 'ndebele' },
  ne: { id: 'data.languages.ne', defaultMessage: 'Nepali' },
  neURL: { id: 'data.languages.ne.url', defaultMessage: 'nepali' },
  nl: { id: 'data.languages.nl', defaultMessage: 'Dutch' },
  nlURL: { id: 'data.languages.nl.url', defaultMessage: 'dutch' },
  no: { id: 'data.languages.no', defaultMessage: 'Norwegian' },
  noURL: { id: 'data.languages.no.url', defaultMessage: 'norwegian' },
  nso: { id: 'data.languages.nso', defaultMessage: 'Sepedi' },
  nsoURL: { id: 'data.languages.nso.url', defaultMessage: 'sepedi' },
  ny: {
    id: 'data.languages.ny',
    defaultMessage: 'Nyanja / Chewa (Chinyanja / Chinyanja)',
  },
  nyURL: { id: 'data.languages.ny.url', defaultMessage: 'nyanja-chewa' },
  nya: { id: 'data.languages.nya', defaultMessage: 'Chichewa' },
  nyaURL: { id: 'data.languages.nya.url', defaultMessage: 'chichewa' },
  nyn: { id: 'data.languages.nyn', defaultMessage: 'Runyakitara' },
  nynURL: { id: 'data.languages.nyn.url', defaultMessage: 'runyakitara' },
  or: { id: 'data.languages.or', defaultMessage: 'Indian Oriya' },
  orURL: { id: 'data.languages.or.url', defaultMessage: 'indian-oriya' },
  orm: { id: 'data.languages.orm', defaultMessage: 'Oromo' },
  ormURL: { id: 'data.languages.orm.url', defaultMessage: 'oromo' },
  pa: { id: 'data.languages.pa', defaultMessage: 'Punjabi' },
  paURL: { id: 'data.languages.pa.url', defaultMessage: 'punjabi' },
  pcm: { id: 'data.languages.pcm', defaultMessage: 'Pidgin' },
  pcmURL: { id: 'data.languages.pcm.url', defaultMessage: 'pidgin' },
  pl: { id: 'data.languages.pl', defaultMessage: 'Polish' },
  plURL: { id: 'data.languages.pl.url', defaultMessage: 'polish' },
  ps: { id: 'data.languages.ps', defaultMessage: 'Pashto' },
  psURL: { id: 'data.languages.ps.url', defaultMessage: 'pashto' },
  pt: { id: 'data.languages.pt', defaultMessage: 'Portuguese Universal' },
  ptURL: {
    id: 'data.languages.pt.url',
    defaultMessage: 'portuguese-universal',
  },
  rn: { id: 'data.languages.rn', defaultMessage: 'Kirundi' },
  rnURL: { id: 'data.languages.rn.url', defaultMessage: 'kirundi' },
  ro: { id: 'data.languages.ro', defaultMessage: 'Romanian' },
  roURL: { id: 'data.languages.ro.url', defaultMessage: 'romanian' },
  ru: { id: 'data.languages.ru', defaultMessage: 'Russian' },
  ruURL: { id: 'data.languages.ru.url', defaultMessage: 'russian' },
  rw: { id: 'data.languages.rw', defaultMessage: 'Kinyarwandan' },
  rwURL: { id: 'data.languages.rw.url', defaultMessage: 'kinyarwandan' },
  sa: { id: 'data.languages.sa', defaultMessage: 'Sanskrit' },
  saURL: { id: 'data.languages.sa.url', defaultMessage: 'sanskrit' },
  se: { id: 'data.languages.se', defaultMessage: 'Sami' },
  seURL: { id: 'data.languages.se.url', defaultMessage: 'sami' },
  she: { id: 'data.languages.she', defaultMessage: 'Sheng' },
  sheURL: { id: 'data.languages.she.url', defaultMessage: 'sheng' },
  si: { id: 'data.languages.si', defaultMessage: 'Sinhalese' },
  siURL: { id: 'data.languages.si.url', defaultMessage: 'sinhalese' },
  sk: { id: 'data.languages.sk', defaultMessage: 'Slovak' },
  skURL: { id: 'data.languages.sk.url', defaultMessage: 'slovak' },
  sl: { id: 'data.languages.sl', defaultMessage: 'Slovenian' },
  slURL: { id: 'data.languages.sl.url', defaultMessage: 'slovenian' },
  sn: { id: 'data.languages.sn', defaultMessage: 'Shona' },
  snURL: { id: 'data.languages.sn.url', defaultMessage: 'shona' },
  so: { id: 'data.languages.so', defaultMessage: 'Somali' },
  soURL: { id: 'data.languages.so.url', defaultMessage: 'somali' },
  sq: { id: 'data.languages.sq', defaultMessage: 'Albanian' },
  sqURL: { id: 'data.languages.sq.url', defaultMessage: 'albanian' },
  sr: { id: 'data.languages.sr', defaultMessage: 'Serbian' },
  srURL: { id: 'data.languages.sr.url', defaultMessage: 'serbian' },
  ss: { id: 'data.languages.ss', defaultMessage: 'Swati' },
  ssURL: { id: 'data.languages.ss.url', defaultMessage: 'swati' },
  st: { id: 'data.languages.st', defaultMessage: 'Sotho' },
  stURL: { id: 'data.languages.st.url', defaultMessage: 'sotho' },
  sv: { id: 'data.languages.sv', defaultMessage: 'Swedish' },
  svURL: { id: 'data.languages.sv.url', defaultMessage: 'swedish' },
  sw: { id: 'data.languages.sw', defaultMessage: 'Swahili' },
  swURL: { id: 'data.languages.sw.url', defaultMessage: 'swahili' },
  'sw-UG': {
    id: 'data.languages.sw-UG',
    defaultMessage: 'Swahili (Uganda)'
  },
  'sw-UGURL': {
    id: 'data.languages.sw-UG.url',
    defaultMessage: 'swahili-uganda'
  },
  ta: { id: 'data.languages.ta', defaultMessage: 'Tamil' },
  taURL: { id: 'data.languages.ta.url', defaultMessage: 'tamil' },
  te: { id: 'data.languages.te', defaultMessage: 'Indian Telugo' },
  teURL: { id: 'data.languages.te.url', defaultMessage: 'indian-telugo' },
  th: { id: 'data.languages.th', defaultMessage: 'Thai' },
  thURL: { id: 'data.languages.th.url', defaultMessage: 'thai' },
  ti: { id: 'data.languages.ti', defaultMessage: 'Tigrinya' },
  tiURL: { id: 'data.languages.ti.url', defaultMessage: 'tigrinya' },
  tl: { id: 'data.languages.tl', defaultMessage: 'Tagalog' },
  tlURL: { id: 'data.languages.tl.url', defaultMessage: 'tagalog' },
  tn: { id: 'data.languages.tn', defaultMessage: 'Setswana' },
  tnURL: { id: 'data.languages.tn.url', defaultMessage: 'setswana' },
  tr: { id: 'data.languages.tr', defaultMessage: 'Turkish' },
  trURL: { id: 'data.languages.tr.url', defaultMessage: 'turkish' },
  ts: { id: 'data.languages.ts', defaultMessage: 'Tsonga' },
  tsURL: { id: 'data.languages.ts.url', defaultMessage: 'tsonga' },
  tw: { id: 'data.languages.tw', defaultMessage: 'Twi' },
  twURL: { id: 'data.languages.tw.url', defaultMessage: 'twi' },
  uk: { id: 'data.languages.uk', defaultMessage: 'Ukrainian' },
  ukURL: { id: 'data.languages.uk.url', defaultMessage: 'ukrainian' },
  ur: { id: 'data.languages.ur', defaultMessage: 'Urdu' },
  urURL: { id: 'data.languages.ur.url', defaultMessage: 'urdu' },
  ve: { id: 'data.languages.ve', defaultMessage: 'Venda' },
  veURL: { id: 'data.languages.ve.url', defaultMessage: 'venda' },
  vi: { id: 'data.languages.vi', defaultMessage: 'Vietnamese' },
  viURL: { id: 'data.languages.vi.url', defaultMessage: 'vietnamese' },
  vmw: { id: 'data.languages.vmw', defaultMessage: 'Makhuwa' },
  vmwURL: { id: 'data.languages.vmw.url', defaultMessage: 'makhuwa' },
  wo: { id: 'data.languages.wo', defaultMessage: 'Wolof' },
  woURL: { id: 'data.languages.wo.url', defaultMessage: 'wolof' },
  xh: { id: 'data.languages.xh', defaultMessage: 'Xhosa' },
  xhURL: { id: 'data.languages.xh.url', defaultMessage: 'xhosa' },
  yo: { id: 'data.languages.yo', defaultMessage: 'Yoruba' },
  yoURL: { id: 'data.languages.yo.url', defaultMessage: 'yoruba' },
  yue: { id: 'data.languages.yue', defaultMessage: 'Chinese-Cantonese' },
  yueURL: { id: 'data.languages.yue.url', defaultMessage: 'chinese-cantonese' },
  zh: { id: 'data.languages.zh', defaultMessage: 'Chinese-Mandarin' },
  zhURL: { id: 'data.languages.zh.url', defaultMessage: 'chinese-mandarin' },
  zu: { id: 'data.languages.zu', defaultMessage: 'Zulu' },
  zuURL: { id: 'data.languages.zu.url', defaultMessage: 'zulu' },
})
